function getHeaderTh(event) {
  let targetNode = event.target
  while (targetNode && targetNode.tagName !== 'TH') {
    targetNode = targetNode.parentNode
  }
  return targetNode
}

function eventsFactory ({ column, store }) {
  if (!column || column.resizable === false) {
    return {}
  }
  const handleMouseMove = (event) => {
    const { renderData } = store.states
    if (renderData.length === 0) return false
    if (!column || column.resizable === false || (!store.table.$props.dynamicHeightResizable && store.usingDynamicHeight)) { return false }
    const targetNode = getHeaderTh(event)
    if (targetNode) {
      const heplerLineNodeAnchor = store.table.$refs.heplerLineAnchor
      store.states.verHelperLine.handleMouseMoveTarget(event, column, 'TH', {
        heplerLineNodeAnchor,
        targetNode,
        targetContainerNode: store.table.$el,
      })
    }
  }
  return {
    mousemove: handleMouseMove
  }
}

export function createHeaderTh () {
  return {
    name: 'headerTh',
    functional: true,
    render (h, context) {
      const props = context.props
      const { column, type } = props
      const { colSpan, rowSpan } = column || {}
      const [slots] = context.slots().default || []
      const on = eventsFactory(props)
      const className = column.key
      column.tableType = type
      return (
        <th
          data-cellKey={column.key}
          data-head-cellKey={column.key}
          {
            ...{
              attrs: colSpan === 0 && rowSpan === 0 ? null : {
                colSpan,
                rowSpan,
              },
              on
            }
          }
          data-helpline-key={type + className}
          >
          {
            slots
          }
        </th>
      )
    },
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/header-thead/th.js